import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, map, shareReplay } from 'rxjs';
import { APIService } from '../api/api.service';
import { cloneDeep } from 'lodash';
import { IAPIResponse } from '../../models/api.interface';
import { IOrgConfig } from '../../models/org-config.interface';

@Injectable({
  providedIn: 'root'
})
export class OrganizationConfigService {
  private orgConfig$: Observable<IOrgConfig> | undefined;

  constructor(private apiSvc: APIService) { }

  get isLivePersonEnabled(): boolean {
    return environment.livePerson.isEnabled;
  }

  get livePersonSiteId(): string | null {
    return environment.livePerson.siteId || null;
  }

  get isAdobeAnalyticsEnabled(): boolean {
    return environment.adobeAnalytics.isEnabled;
  }

  get adobeAnalyticsScriptUrl(): string | null {
    return environment.adobeAnalytics.scriptUrl || null;
  }

  get orgConfig(): Observable<IOrgConfig> {
    if (!this.orgConfig$) {
      this.orgConfig$ = this.getOrgConfig().pipe(
        map(apiResponse => apiResponse?.response?.organization),
        map((config) => cloneDeep(config)),
        shareReplay(1)
      );
    }
    return this.orgConfig$;
  }

  private getOrgConfig(): Observable<IAPIResponse> {
    return this.apiSvc.get$<IAPIResponse>('/organizations/configs');
  }
}
